"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.create = exports.getData = void 0;
var assert_sidecar_1 = require("../lib/assert-sidecar");
var common_sidecar_1 = require("../main/common-sidecar");
var _data = null;
var getData = function () {
    assert_sidecar_1.assert.notNil(_data);
    return _data;
};
exports.getData = getData;
var create = function (layer) {
    // let text = stevieTexts2.create(
    //   echoFonts.getData().font6, //ctx.font16,
    //   700,
    //   500,
    //   layer,
    // )
    // stevieTexts2.setText(text, 'FPS')
    // stevieTexts2.setScale(text, 3)
    _data = {
        isOpen: false,
        //  textFps: text,
    };
    exports.setOpen(true);
};
exports.create = create;
var setOpen = function (isOpen, isSemiOpen) {
    if (isSemiOpen === void 0) { isSemiOpen = false; }
    var data = exports.getData();
    data.isOpen = isOpen;
    //  stevieTexts2.setVisible(data.textFps, isOpen && !isSemiOpen)
};
exports.setOpen = setOpen;
var update = function (cb) {
    var s = common_sidecar_1.common.getPhaserScene();
    var data = exports.getData();
    if (data && data.isOpen) {
        var fps = Math.round(s.game.loop.actualFps);
        if (fps === 59 || fps === 61) {
            fps = 60;
        }
        cb(fps);
        // stevieTexts2.setText(data.textFps, '' + fps)
        // // stevieTexts.moveTo(data.textFps, 1, window.innerHeight - 20)
        // // let b = underCamera.getGameBounds()
        // stevieTexts2.moveTo(data.textFps, gb.width - 20, gb.height - 12)
    }
};
exports.update = update;
